import { useMemo } from "react";
import { useChartCompareSetSelectContext } from "components/charting/contexts/ChartCompareSetSelectContext";
import { useChartSetSelectContext } from "components/charting/contexts/ChartSetSelectContext";
import { useChartProfileSelectContext } from "components/charting/contexts/ChartProfileSelectContext";
import { useChartCompareProfileSelectContext } from "components/charting/contexts/ChartCompareProfileSelectContext";
import ProfilingComparisonContext from "components/charting/contexts/ProfilingComparisonContext";
import { ProfilingChartEntityId } from "components/charting/types";
import ChartColorRegistryProvider from "features/Charting/providers/ChartColorRegistryProvider";

interface AthleteProfilingChartEntityColorProviderProps {
  children?: React.ReactNode;
}

function AthleteProfilingChartEntityColorProvider(props: AthleteProfilingChartEntityColorProviderProps) {
  const { value: selectedSets } = useChartSetSelectContext();
  const { value: selectedProfiles } = useChartProfileSelectContext();
  const { value: selectedCompareSets } = useChartCompareSetSelectContext();
  const { value: selectedCompareProfiles } = useChartCompareProfileSelectContext();

  const isComparison = Boolean(
    (selectedSets.length || selectedProfiles.length) && (selectedCompareSets.length || selectedCompareProfiles.length)
  );

  const entityIds = useMemo(
    () =>
      ([] as string[])
        .concat(ProfilingChartEntityId.PROFILING_LINE, ProfilingChartEntityId.COMPARATIVE_LINE)
        .concat(...selectedSets.map((v) => v.measurementId))
        .concat(...selectedCompareSets.map((v) => v.measurementId)),
    [selectedCompareSets, selectedSets]
  );

  return (
    <ProfilingComparisonContext.Provider value={isComparison}>
      <ChartColorRegistryProvider entityIds={entityIds}>{props.children}</ChartColorRegistryProvider>
    </ProfilingComparisonContext.Provider>
  );
}

export default AthleteProfilingChartEntityColorProvider;
